import { Box } from '@mui/material';
import type { FC } from 'react';
import { ReactSVG } from 'react-svg';
import type { SvgIconWrapperProps } from './SvgIconWrapper.types';

const SvgIconWrapper: FC<SvgIconWrapperProps> = ({ src, className, sxOverrides }) => (
  <Box
    component="span"
    sx={{
      '& .common-icon-style': {
        span: {
          display: 'flex',
          minWidth: '24px',
          minHeight: '24px',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
      ...sxOverrides,
    }}
  >
    <ReactSVG src={src} className={`common-icon-style ${className || ''}`} wrapper="span" />
  </Box>
);

export default SvgIconWrapper;
